export enum BlockBQueries {
  DemandDriverChart = 'demandDriverChart',
}
